import { useEffect, useRef, useState } from "react";
// api services
import apiParticipantes from "../api/Participantes/api-participantes";
// hooks
import { useNavigate } from "react-router";
import { openNotification } from "../utils/Notifactions";
import DocumentosService from "../api/Documentos/api-documentos";
import { guardarDatosPostulacion } from "../redux/actions/participantesAction";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/reducers";
import apiConvocatorias from "../api/Convocatorias/api-convocatorias";
import { useEncrypt } from "./useEncrypt";
import { ObjNotificaciones } from "../config/notificaciones";
import moment from "moment";
import { documentosRescatados, fusionarDocumentos } from "../utils/fusionDocumentos";

export const useDocumentosTecnicos = () => {
  // hooks
  const dispatch = useDispatch();
  const { decrypt } = useEncrypt();
  const { datos_postulacion } = useSelector(
    (state: RootState) => state.participantes
  );
  // state
  const [principalState, setPrincipalState] = useState([]);
  const [documentos, setDocumentos] = useState([]);
  /** Las direcciones eliminadas en esta sesion, para no resucitarlas. */
  const urlsBorradas = useRef<string[]>([]);
  const [loading, setLoading] = useState(false);
  //   route
  const navigate = useNavigate();
  //   redux variables
  useEffect(() => {
    getDocumentos();
  }, []);

  const getDocumentos = async () => {
    const { data } = await apiConvocatorias.obtenerDocumentosTecnicos(decrypt(localStorage.getItem('idConvocatoriaPostulacion')))

    let resp = data.documentos_tecnicos.map((doc: any, index: number) => {
      return {
        id: doc.id,
        idconvocatoria: doc.idconvocatoria,
        descripcion: doc.descripcion,
        obligatorio: doc.obligatorio,
        subsanable: doc.subsanable,
        tipo_documento_id: doc.tipo_documento_id,
        tipo_documento: doc.tipo_documento,
        tipo_persona: doc.tipo_persona,
        url_documento: doc.url_documento,
        url_participante: doc.url_participante,
        escrito: doc.escrito,
        url_video: doc.url_video,
      };
    });
    return setDocumentos(resp);
  };

  const excelTypes = [
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel"
  ];

  const guardarArchivosTecnicos = async (datos: any, e: any, index: any, tipoDoc: any) => {
    if (e.target.files.length > 0) {
      let documento = e.target.files[0];
      console.log(tipoDoc)
      if (documento.size > 5000000) {
        return openNotification({
          titulo: "Error",
          descripcion: "Solo se permiten archivos menores a 5MB",
          placement: "bottomRight",
        });
      }
      if (tipoDoc == 'Presupuesto' || tipoDoc == 'Comparativo cotizaciones') {
        if (!excelTypes.includes(documento.type)) {
          return openNotification({
            titulo: "Error",
            descripcion: "En este documento solo se permiten archivos Excel (.xls, .xlsx)",
            placement: "bottomRight",
          });
        }
      } else {
        if (documento.type !== "application/pdf") {
          return openNotification({
            titulo: "Error",
            descripcion: "En este documento solo se permiten archivos PDF",
            placement: "bottomRight",
          });
        }
      }

      const formData = new FormData();
      formData.append("archivo", documento);
      let data = await DocumentosService.guardarArchivo(formData);

      let nuevosdocumentos: any = documentos.map(
        (doc: any, indexdoc: number) => {
          if (index === indexdoc) {
            return {
              ...doc,
              url_participante: data.data,
              fecha: moment().format("YYYY-MM-DD"),
              hora: moment().format("HH:mm"),
            };
          }
          return {
            ...doc,
          };
        }
      );
      document
        .getElementsByClassName("cards-documentos")
      [index].classList.remove("border-error-cards-documentos");
      setDocumentos(nuevosdocumentos);
      // Auto-guardado silencioso
      await autoGuardarTecnicos(nuevosdocumentos);
      return;
    }
  };

  /** Lo que el servidor tiene guardado ahora mismo. */
  const tecnicosDelServidor = async (id_postulacion: any) => {
    try {
      const respuesta: any = await apiParticipantes.consultarPostulacion(id_postulacion);
      const cuerpo = respuesta?.data ?? respuesta;
      const postulacion = Array.isArray(cuerpo) ? cuerpo[0] : cuerpo;
      return postulacion?.documentos_tecnicos ?? [];
    } catch (error) {
      // Si no se puede releer se sigue con lo que hay: es mejor guardar que
      // perder lo que la persona acaba de subir.
      console.error("No se pudo releer los documentos tecnicos antes de guardar", error);
      return [];
    }
  };

  /**
   * El unico sitio que escribe los documentos tecnicos. El backend reemplaza
   * la columna entera con lo que reciba, asi que antes se mira que hay
   * guardado y se fusiona.
   */
  const escribirTecnicos = async (id_postulacion: any, docsDelCliente: any) => {
    const enServidor = await tecnicosDelServidor(id_postulacion);
    const aGuardar = fusionarDocumentos(enServidor, docsDelCliente, urlsBorradas.current);

    const rescatados = documentosRescatados(enServidor, docsDelCliente, urlsBorradas.current);
    if (rescatados > 0) {
      console.warn(
        `Se conservaron ${rescatados} documento(s) tecnico(s) que esta pantalla no tenia cargados.`
      );
    }

    await apiParticipantes.guardarDocumentosTecnicosPostulacion(id_postulacion, aGuardar);
    return aGuardar;
  };

  const autoGuardarTecnicos = async (docsToSave: any) => {
    try {
      const id_postulacion = decrypt(localStorage.getItem('id_postulacion'));
      await escribirTecnicos(id_postulacion, docsToSave);
      await apiParticipantes.actualizarEstadoPostulacionArtista(id_postulacion, "Por completar");
      dispatch(
        guardarDatosPostulacion({
          ...datos_postulacion,
          documentosTecnicos: docsToSave,
        })
      );
    } catch (error) {
      console.error("Auto-guardado técnicos falló:", error);
    }
  };



  const eliminarArchivo = async (e: any, index: number, tipoDocumento: string) => {
    const borrada = documentos[index].url_participante;
    await DocumentosService.eliminarArchivo(borrada);
    if (borrada) urlsBorradas.current.push(borrada);
    let nuevosdocumentos: any = documentos.map((doc: any, indexdoc: number) => {
      if (tipoDocumento === doc.tipo_documento) {
        return {
          ...doc,
          url_participante: "",
        };
      }
      return {
        ...doc,
      };
    });
    return setDocumentos(nuevosdocumentos);
  };

  const consultarArchivos = async (guardar?: boolean) => {
    const id_postulacion = decrypt(localStorage.getItem('id_postulacion'));

    let error = false;
    documentos.forEach((doc: any, indexdoc: number) => {
      const isEscritoVideo = doc.tipo_documento === "Escrito y Video";
      if (isEscritoVideo) {
        if (!doc.escrito || doc.escrito === "" || !doc.url_video || doc.url_video === "") {
          document.getElementsByClassName("cards-documentos")[indexdoc].className += " border-error-cards-documentos";
          error = true;
        }
      } else {
        if (!doc.url_participante || doc.url_participante === "") {
          document.getElementsByClassName("cards-documentos")[indexdoc].className += " border-error-cards-documentos";
          error = true;
        }
      }
    });

    if (error) {
      return;
    }

    try {
      setLoading(true);
      await escribirTecnicos(decrypt(localStorage.getItem("id_postulacion")), documentos);
      dispatch(
        guardarDatosPostulacion({
          ...datos_postulacion,
          documentosTecnicos: documentos,
        })
      );
      setLoading(false);
      if (guardar) {
        await apiParticipantes.actualizarEstadoPostulacionArtista(id_postulacion, "Por completar");
        ObjNotificaciones.MSG_SUCCESS("¡Guardado!", "Se ha guardado la información correctamente");
        return navigate("/Usuario");
      } else {
        return navigate("/usuario/Agregarurl");
      }
    } catch (error) {
      setLoading(false);
      return console.error(error);
    }
  };

  return {
    principalState,
    setPrincipalState,
    guardarArchivosTecnicos,
    // Lo necesita el modal de escrito y video, que hasta ahora solo
    // actualizaba la pantalla.
    autoGuardarTecnicos,
    eliminarArchivo,
    consultarArchivos,
    getDocumentos,
    documentos,
    setDocumentos,
    loading,
  };
};
